export const mobileDrawerOverdragResistance = 0.24;
export const mobileDrawerOpenSpring = { tension: 360, friction: 34 };
export const mobileDrawerCloseSpring = { tension: 300, friction: 24 };
